import { Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { AoiService } from '../../../services/aoi.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-state',
    templateUrl: './state.component.html',
    styleUrls: ['../../sharedStyles/base.scss']
})
export class StateComponent extends BaseComponent {
    @Input()
    public get AoiService() {
        return this.aoiService;
    }

    constructor(
        _vcr: ViewContainerRef,
        private readonly aoiService: AoiService
    ) {
        super(_vcr, true);
    }

    @Input()
    public activate = () => {}

    @Input()
    public addResultToMap = () => {
        this.aoiService.setSearchCriterias([{ type: 'state' }]);
    }
}
